import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './HardwareFirstValueProps.module.scss';

/**
 * Shipping, returns and warranty as three cards. Shared by the plp and the cart - kept as a leaf
 * module so the cart does not pull the plp's below-fold sections into its bundle.
 */
export default function HardwareFirstValueProps() {
  const { t } = useTranslation();
  const boxes = [
    { title: t('free_shipping'), sub: t('hardware_first_shipping_sub') },
    { title: t('hardware_first_returns_title'), sub: t('hardware_first_returns_sub') },
    { title: t('one_year_warranty'), sub: t('cart_item_v2.warranty_description') },
  ];
  return (
    <div className={styles.valueProps}>
      {boxes.map((box) => (
        <div key={box.title} className={styles.valueProp}>
          <div className={styles.valuePropTitle}>{box.title}</div>
          <div className={styles.valuePropSub}>{box.sub}</div>
        </div>
      ))}
    </div>
  );
}
